<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { Underline } from "ls/common/keyboardShortcuts";
import { UnderlineIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .setUnderline()
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="UnderlineIcon"
    :shortcut="Underline"
    @click="run"
    @keydown.enter="run"
  >
    Underline
  </SuggestionListItem>
</template>
